import React from 'react';
import { connect } from 'react-redux';
import Dialog from '../../../base/ui/components/web/Dialog';
import { translate } from '../../../base/i18n/functions';
import AbstractKickToLobbyDialog from '../AbstractKickToLobbyDialog';
/**
 * Dialog to confirm a remote participant kick to lobby action.
 */
class KickToLobbyDialog extends AbstractKickToLobbyDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement(Dialog, { ok: { translationKey: 'dialog.kickToLobbyButton' }, onSubmit: this._onSubmit, titleKey: 'dialog.kickToLobbyTitle' },
            React.createElement("div", null, this.props.t('dialog.kickToLobbyDialog'))));
    }
}
export default translate(connect()(KickToLobbyDialog));
